/**
 * Check if a shift is in the past (end time has passed)
 * @param {string} date - Date in YYYY-MM-DD format
 * @param {string} endTime - End time in HH:MM format (24-hour)
 * @returns {boolean} - True if the shift is in the past
 */
export const isShiftInPast = (date, endTime) => {
  if (!date || !endTime) return false;

  // Create a date object for the shift end time in local timezone
  const [year, month, day] = date.split("-").map(Number);
  const [hours, minutes] = endTime.split(":").map(Number);

  const shiftEndDate = new Date(year, month - 1, day, hours, minutes, 0, 0);
  const now = new Date();

  return shiftEndDate < now;
};

/**
 * Format an activity timestamp for the activity tables (dashboard and
 * reporting). Matches the long-date style used on the reporting reports page
 * (e.g. "August 21, 2025") but with a 24-hour clock — e.g. "August 21, 2025,
 * 14:30". Returns an empty string when there's no value.
 * @param {string|number|Date} value - A date/timestamp value
 * @returns {string} - Formatted date-time, or "" when value is falsy
 */
export const formatActivityDateTime = (value) => {
  if (!value) return "";
  return new Date(value).toLocaleString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  });
};

/**
 * Check if a shift is in the past based on shift data object
 * @param {Object} shiftData - Shift data object with date and end time
 * @returns {boolean} - True if the shift is in the past
 */
export const isShiftDataInPast = (shiftData) => {
  if (!shiftData) return false;

  // Handle different data structures
  if (shiftData.date && shiftData.endTime) {
    return isShiftInPast(shiftData.date, shiftData.endTime);
  }

  if (shiftData.end_time) {
    const endDate = new Date(shiftData.end_time);
    const now = new Date();
    return endDate < now;
  }

  return false;
};
